// extracted by mini-css-extract-plugin
export default {"CategorySubTitle":"CategorySubTitle_CategorySubTitle__7vOGm"};